import axios from 'axios';
import _ from "lodash";
import { environment } from "./config";
import { getAuthInterceptor } from './authInterceptor';

interface IProblemDetails {
    type: string;
    title: string;
    status: number;
    detail: string;
    traceId: string;
    subCode?: number;
    errorCodes?: Record<string, string[]>;
}

export class ErrorDetails {
    public code: number;
    public subCode?: number;
    public message: string;
    public detail?: string;
    public errorCodes?: Record<string, string[]>;

    constructor(code: number, message: string, subCode?: number, detail?: string, errorCodes?: Record<string, string[]>) {
        this.code = code;
        this.message = message;
        this.subCode = subCode;
        this.detail = detail;
        this.errorCodes = errorCodes;
    }

    hasValidationError(field: string, code: string): boolean {
        console.debug(`Checking validation error for field: ${field}, code: ${code}`);
        return this.errorCodes?.[field]?.some(error => error === code) ?? false;
    }

    getAllValidationErrorCodes(): string[] {
        console.debug("Retrieving all validation error codes: ", _.values(this.errorCodes ?? {}).flat());
        return _.values(this.errorCodes ?? {}).flat();
    }
}

const apiClientInstance = axios.create({ baseURL: environment[window.location.host] });

apiClientInstance.interceptors.request.use(getAuthInterceptor());

apiClientInstance.interceptors.response.use(undefined, error => {
    const response = error.response?.data as IProblemDetails;
    if (!response) {
        return Promise.reject(error);
    }

    const errorDetails = new ErrorDetails(response.status, response.title, response.subCode, response.detail, response.errorCodes);
    return Promise.reject(errorDetails);
});

export const apiClient = apiClientInstance;